// Dimension → unit token mapping per response language (TL-1 migration from aiUtils.js).
// Backend ai_intention.available_fields의 dimension 메타 기반 — 정규식 추격 X.
// 새 언어 추가 시 본 테이블만 확장. dimension enum 자체는 backend가 정의 (언어 무관).
export const UNIT_BY_DIMENSION = {
  rate:        { ko: '%',   en: '%',         ja: '%' },         // 비율/이탈률/출석률 (국제 기호)
  currency:    { ko: '원',  en: 'KRW',       ja: '円' },
  people:      { ko: '명',  en: ' people',   ja: '人' },
  transaction: { ko: '건',  en: ' items',    ja: '件' },
  session:     { ko: '회',  en: ' sessions', ja: '回' },
  object:      { ko: '개',  en: ' units',    ja: '個' },
  none:        { ko: '',    en: '',          ja: '' },
};
